import React from 'react'
import './contact.css';
import { useTranslation } from 'react-i18next';


export function Contact(){
    const { t } = useTranslation();
    return(
        <div className="contact_content_div w-100 text-center float-start">

            <div className="contact_content_div_marge mx-auto text-start contact_content_div_marge_resp ">
                <div className="contact_input_label_div" >
                    <div className="contact_label_div"  ><label required htmlFor="contact_name_input" className= "control-label required-field w-100 fw-bold">{t("name")}</label> </div>
                    <div className="contact_Input_div contact_Input_div_resp"><input required className="contactInput" name="nameInput" placeholder='Nom' /></div>
                </div>
                

                <div className="contact_input_label_div" >
                    <div className="contact_label_div"><label className="required-field fw-bold">E-mail</label></div> 
                    <div className="contact_Input_div contact_Input_div_resp"><input className="contactInput" name="emailInput" placeholder='E-Mail' /></div>
                </div>


                <div className="contact_input_label_div" >
                    <div className="contact_label_div"><label className="w-100 fw-bold">{t("phone")}</label></div> 
                    <div className="contact_Input_div contact_Input_div_resp"><input className="contactInput" name="emailInput" placeholder='phone number' /></div>
                </div>

                <div className="contact_input_label_div" >
                    <div className="contact_label_div"><label className=" required-field fw-bold">Message</label></div> 
                    <div className="contact_Input_div contact_Input_div_resp"><textarea className="contactInput contact_areaText" type="textArea" name="emailInput" placeholder='Message' /></div>
                </div>

                <div className="contact_input_label_div" >
                    <div className="contact_button_div"><button className="contact_submite_button">{t("send")}</button></div> 
                </div>

                <hr></hr>

                <div className="emailContactcontainer"><p>{t("contactMsg")}<br></br><br></br>
                <span className="fw-bold">tadlaoui.said@al-ts-stud-morocco.com </span></p><br></br><br></br></div>

                <div className="sepDiv"></div>
                
               

            </div>



        </div>
    )
}
export default Contact